import { Popover as BasePopover } from '@base-ui/react/popover'
import type { FC, ReactNode } from 'react'
import paperStyles from './paper.module.css'

export interface PopoverProps {
  open: boolean
  onClose?: () => void
  anchorEl?: HTMLElement | null
  anchorOrigin?: { vertical: 'top' | 'center' | 'bottom'; horizontal: 'left' | 'center' | 'right' }
  className?: string
  style?: React.CSSProperties
  children?: ReactNode
}

const anchorToSide = (anchorOrigin?: PopoverProps['anchorOrigin']): 'top' | 'bottom' | 'left' | 'right' => {
  if (!anchorOrigin) {
    return 'bottom'
  }
  if (anchorOrigin.vertical === 'top') {
    return 'top'
  }
  if (anchorOrigin.vertical === 'bottom') {
    return 'bottom'
  }
  if (anchorOrigin.horizontal === 'left') {
    return 'left'
  }
  return 'right'
}

export const Popover: FC<PopoverProps> = ({ open, onClose, anchorEl, anchorOrigin, className, children, style }) => {
  const classes = [paperStyles.paper, paperStyles.elevation4, className].filter(Boolean).join(' ')

  return (
    <BasePopover.Root
      open={open}
      onOpenChange={o => {
        if (!o) {
          onClose?.()
        }
      }}
    >
      <BasePopover.Portal>
        <BasePopover.Positioner
          anchor={anchorEl ?? undefined}
          side={anchorToSide(anchorOrigin)}
          style={{ zIndex: 'var(--tuna-zIndex-modal)' as never }}
        >
          <BasePopover.Popup className={classes} style={style}>
            {children}
          </BasePopover.Popup>
        </BasePopover.Positioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  )
}
